import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import routes from '../../config/routes';
import PrivateRoute from './private-route';

const CustomRoute = (route) => {
  if (route.private === false) {
    return (
      <Route
        path={route.path}
        render={props => (
          <route.component{...props} />
        )}
      />
    )
  }

  return (
    <PrivateRoute
      path={route.path}
      layout={route.headless === true ? 'headless' : 'base'}
      component={props => (
        <route.component
          {...props}
        />
      )}
    />
  )
}

class Router extends Component {
  render() {
    return (
      <Switch>
        {routes.map((route, i) => <CustomRoute key={i} {...route} />)}
      </Switch>
    )
  }
}

export default Router;